const GOOGLE_CONTACTS_SCOPE = 'https://www.googleapis.com/auth/contacts.readonly';

export const buildGoogleAuthUrl = (clientId, redirectUri) => {
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'token',
    scope: GOOGLE_CONTACTS_SCOPE,
    include_granted_scopes: 'true',
    prompt: 'consent',
  });

  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};

export const buildGoogleContactsApiUrl = (accessToken, pageToken = '', pageSize = 100) => {
  const params = new URLSearchParams({
    personFields: 'names,emailAddresses,phoneNumbers',
    access_token: accessToken,
    pageSize: String(pageSize),
  });

  if (pageToken) {
    params.set('pageToken', pageToken);
  }

  return `https://people.googleapis.com/v1/people/me/connections?${params.toString()}`;
};

const normalizePhoneNumber = (value) => {
  if (!value) return '';
  const digits = String(value).replace(/\D/g, '');
  if (!digits) return '';

  if (digits.startsWith('91') && digits.length > 10) {
    return digits;
  }

  if (digits.length === 10) {
    return `91${digits}`;
  }

  if (digits.startsWith('0')) {
    return `91${digits.slice(1)}`;
  }

  return digits;
};

export const normalizeGoogleContacts = (contacts = []) => {
  return contacts
    .map((contact, index) => {
      const name = contact?.names?.[0]?.displayName || '';
      const email = contact?.emailAddresses?.[0]?.value || '';
      const phone = normalizePhoneNumber(contact?.phoneNumbers?.[0]?.canonicalForm || contact?.phoneNumbers?.[0]?.value || '');
      const prefix = "";

      return {
        id: contact?.resourceName || `google-contact-${index}`,
        name,
        email,
        phone,
        address: '',
        gstin: '',
        status: 'active',
        prefix,
      };
    })
    .filter((entry) => entry.name || entry.email || entry.phone);
};

export const getSelectedGoogleContacts = (contacts = [], selectedIds = []) => {
  const selectedIdSet = new Set(selectedIds);
  return contacts.filter((contact) => selectedIdSet.has(contact.id));
};

export const applyPrefixToContacts = (contacts = [], prefix = '') => {
  const normalizedPrefix = prefix?.trim() || '';
  console.log('Applying prefix to contacts:', normalizedPrefix);
  return contacts.map((contact) => ({
    ...contact,
    prefix: normalizedPrefix || contact.prefix || '',
  }));
};
